import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';

import { setSplashError } from "../../../actions/index";

function Player({ html }) {
  const dispatch = useDispatch();

  useEffect(() => {
    let isExist = false;
    if (window.YouDJ && window.YouDJ.init) {
      window.YouDJ.player_ready = () => {
        if (window.all_ready) {
          window.all_ready();
        } else {
          dispatch(setSplashError({ title: 'Bridge Error', message: 'The player is connected to the library - Need the required method `all_ready` in the bridge' }));
        }
      }
      window.YouDJ.init();
      (window.document_ready) && window.document_ready(); // LOAD CORE AUDIO
      isExist = true;
      const base = document.getElementById(`alpha2`);
      if (base) {
        base.oncontextmenu = () => false;
      }
    }
    if (!isExist) {
      const resize = () => {
        isExist ? window.DJAPPMM.resize(document.getElementById("DJAPPMM_container").clientWidth, document.getElementById("DJAPPMM_container").clientHeight) : window.DJAPPMM.resize();
      }
      window.onresize = () => { resize() }
      resize();
    }

  }, [dispatch])

  return <div dangerouslySetInnerHTML={{ __html: html }}></div>
}

Player.propTypes = {
  html: PropTypes.string.isRequired
}

export default Player;
